import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';

const featuresData = [
  {
    title: 'Speech bubbles',
    text: 'Audio conversations will be transcribed into texts using speech-to-text technology and the texts will be displayed as speech bubbles. Each person has their own speech bubble column displayed in different colours.',
  },
  {
    title: 'Bookmark function',
    text: 'User can bookmark a specific conversation by selecting the target speech bubble to reply.',
  },
  {
    title: 'Emotion expression',
    text: 'Options including emoji, sticker, GIF, the user\’s recorded voice or sound with a range of tones/volume/speed conveying different emotions are provided.',
  },
  {
    title: 'Word prediction',
    text: 'After choosing a speech bubble, predicted responses using AI algorithms will be offered to increase communication speed.',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">The Future is Now and You Just Need to Realize It. Step into Future Today. & Make it Happen.</h1>
      <p>Request Early Access to Get Started</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;